import { Injectable } from '@angular/core';
import { LicenseTypeEnum } from './license-type.enum';
import { ILicenseService } from './ilicense.service';
import { ApiService } from '../index';

@Injectable()
export class LicenseService implements ILicenseService {
  public _apiService: ApiService;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
  }

  // calls the "feature/has" end point to determine if a client has access to a feature
  public has = (license: LicenseTypeEnum): Promise<boolean> => {
    let url: string = '/license/has' + LicenseTypeEnum[license];
    return this._apiService.get(url);
  };
}
